import { memo } from 'react'
import { DoubleBets } from '../organisms/DoubleBets'
import { DoubleForm } from '../organisms/DoubleForm'
import { DoubleHistoryBets } from '../organisms/DoubleHistoryBets'
import { DoubleRolling } from '../organisms/DoubleRolling'
import { Grid } from '@chakra-ui/react'

export const DoubleGame = memo(() => {
  return (
    <Grid>
      <DoubleRolling />
      <DoubleControlPanel />
      <DoubleHistoryBets />
    </Grid>
  )
})

const DoubleControlPanel = () => {
  return (
    <>
      <DoubleForm />
      <DoubleBets />
    </>
  )
}
